import React, { useState } from 'react'
import Payment from 'payment'
import {
  Button,
  Form,
  InputGroup, Alert
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import { ValidateForm } from './CreditCardValidator'
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate
} from "./utils"
import axios from 'axios'


const PaymentForm = () => {
  const [cardNum, setCardNum] = useState('')
  const [cardName, setCardName] = useState('')
  const [cardExp, setCardExp] = useState('')
  const [cardCvv, setCardCvv] = useState('')
  const [cardIssuer, setCardIssuer] = useState('')
  const [cardSave, setCardSave] = useState(false)
  const [errorMsg, setErrorMessage] = useState('success')

  const handleInputChange = (event) => {
    if (event.target.name === "number") {
      event.target.value = formatCreditCardNumber(event.target.value)
      setCardNum(event.target.value)
      setCardIssuer(Payment.fns.cardType(event.target.value))
    } else if (event.target.name === "expiry") {
      event.target.value = formatExpirationDate(event.target.value)
      setCardExp(event.target.value)
    } else if (event.target.name === "cvv") {
      event.target.value = formatCVC(event.target.value, cardIssuer)
      setCardCvv(event.target.value)
    } else if (event.target.name === "name") {
      setCardName(event.target.value)
    } else if (event.target.name === "save") {
      setCardSave(!cardSave)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    let formData = {
      'name': cardName,
      'card_num': cardNum,
      'date': cardExp,
      'cvv': cardCvv,
      'save': cardSave,
      'issuer': cardIssuer
    }
    let validation = ValidateForm(formData)
    if(validation['message'] !== 'success'){
      setErrorMessage(validation['message'])
    }else{
      setErrorMessage('success')
      fetch('/post-form', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        // window.alert(response.body)
        // console.log(response.text())
        console.log(response.json())
      })
      .catch(error => console.error(error))
    }
  }

  return (
    <div className='container p-3 w-25'>
      <Form onSubmit={handleSubmit}>
        <InputGroup className='mb-3'>
          <Form.Control
            name="number"
            placeholder='Card Number'
            pattern="[\d| ]{16,22}"
            onChange={handleInputChange}
            required />
        </InputGroup>
        <div className="form-group mb-3">
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="Name"
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="row mb-3">
          <div className="col-6">
            <input
              type="month"
              name="expiry"
              className="form-control"
              placeholder="Valid Thru"
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="col-6">
            <input
              type="tel"
              name="cvv"
              className="form-control"
              placeholder="CVV"
              pattern="\d{3,4}"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <Form.Check name='save' className='mb-3' type="checkbox" label="Save card details for the future" onChange={handleInputChange} checked={cardSave} />
        <input type="hidden" name="issuer" value={cardIssuer} />
        {errorMsg !== 'success' &&
          <Alert variant={'danger'}>{errorMsg}</Alert>
        }
        <div className="form-actions">
          <Button type='submit'>PAY</Button>
        </div>
              
      </Form>
    </div>
  )
}

export default PaymentForm